module.exports = __webpack_public_path__ + "img/placeholder.2f12e704.gif";